(function($){
	/**
	 * Click en campos de contraseña
	 */

	let inputPassword = $('.bar-form-input--password');

	if( inputPassword ){

		inputPassword.each(function(){
			let iconEyeOpen = $('.bar-icon-tools-eyeopen[role="button"]');
			let iconEyeClosed = $('.bar-icon-tools-eyeclose[role="button"]');

			$(this).on('click','.bar-icon-tools-eyeopen[role="button"]',function(e){
				e.preventDefault();
				$(this).removeClass('bar-icon-tools-eyeopen').addClass('bar-icon-tools-eyeclose').closest('.bar-form-input--password').find('input').attr('type','text');
			});

			$(this).on('click','.bar-icon-tools-eyeclose[role="button"]',function(e){
				e.preventDefault();
				$(this).removeClass('bar-icon-tools-eyeclose').addClass('bar-icon-tools-eyeopen').closest('.bar-form-input--password').find('input').attr('type','password');
			})
		});
	}

	/**
	 * Cambio de color del select si la primera opcion está seleccionada y es disabled
	 */

	let select = $('select');

	if(select){

		select.each(function(){

			if($(this).find(':selected').prop('disabled')){
			  $(this).css('color','var(--nc-600)');
			}

			$(this).change(function(e){
				if($(this).find(':selected').prop('disabled')){
				    $(this).css('color','var(--nc-600)');
				}else{
					$(this).css('color','inherit');
				}
			});

		});
	}

	/**
	 * Cambio de color del date
	 */
	let dateField = $('[type="date"]');

	if(dateField){

		dateField.each(function(){

			$(this).css('color','var(--nc-600)');
			$(this).change(function(e){
				$(this).css('color','inherit');
			});

		});
	}
})(jQuery)